module.exports = __webpack_public_path__ + "static/taetigkeitsbereich_background-dc454692f34f9b142282c960f7a2991b.jpg";